import firebase from "../firebase/firebase";
import "firebase/firestore";
import utils from "../utils";
const db = firebase.firestore();

class StudentStore {
  constructor(collectionName) {
    this.collectionName = collectionName;
    //this.response = { isCommitted: false, id: null, error: null };
  }

  getStudents(model) {
    var students = [];
    var studentsCollection = db.collection(this.collectionName);
    var dbModel = model;
    return new Promise(function(resolve, reject) {
      studentsCollection
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //console.log(doc.id, ' => ', doc.data())
            dbModel = Object.assign({}, doc.data());
            dbModel.Id = doc.id;
            students.push(dbModel);
          });
        })
        .catch(function(error) {
          reject(error);
        });
      resolve(students);
    });
  }

  getFilteredStudents(model, filter) {
    var students = [];
    var studentsCollection = db.collection(this.collectionName);
    var dbModel = model;
    return new Promise(function(resolve, reject) {
      /*
        setTimeout(function() {
        
      }, 5000);
      */
      studentsCollection
        .where(filter.Field, filter.Operation, filter.Value)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //console.log(doc.id, ' => ', doc.data())
            dbModel = Object.assign({}, doc.data());
            dbModel.Id = doc.id;
            students.push(dbModel);
          });
        })
        .catch(function(error) {
          reject(error);
        });
      resolve(students);
    });
  }

  getAllStudents(model) {
    var students = [];
    var studentsCollection = db.collection(this.collectionName);
    var dbModel = model;
    return new Promise(function(resolve, reject) {
      /*
        setTimeout(function() {
        
      }, 5000);
      */
      studentsCollection
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //console.log(doc.id, ' => ', doc.data())
            dbModel = Object.assign({}, doc.data());
            dbModel.Id = doc.id;
            students.push(dbModel);
          });
        })
        .catch(function(error) {
          reject(error);
        });
      resolve(students);
    });
  }

  getStudent(Id, model) {
    var studentsCollection = db.collection(this.collectionName);
    var dbModel = model;
    return new Promise(function(resolve, reject) {
      var docRef = studentsCollection.doc(Id);
      docRef
        .get()
        .then(doc => {
          //console.log(doc.id, ' => ', doc.data())
          dbModel = Object.assign({}, doc.data());
          dbModel.Id = doc.id;
          resolve(dbModel);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  addStudent(model) {
    //console.log(model)
    var json = utils.mapDatabaseFields(model);
    var collection = this.collectionName;
    var response = { isSaved: false, error: "", id: null };

    return new Promise(function(resolve, reject) {
      db.collection(collection)
        //.add(studentJson)
        .add(json)
        .then(function(docRef) {
          response.isSaved = true;
          response.id = docRef.id;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  async addStudentToBatch(models, key) {
    var students = [];
    var response = { isCommitted: false, error: "" };
    // Get a new write batch
    var batch = db.batch();
    //const key = db.collection(this.collectionName).doc().id;
    var json = { students: null, studentProfile: null, batch: null };

    console.log(key);
    console.log(models);

    if (
      models.batchModel.Students == undefined ||
      models.batchModel.Students == "" ||
      models.batchModel.Students == []
    ) {
      //first student for the batch
      console.log("first");
      students.push(key);
      models.batchModel.Students = students;
      models.batchModel.NoOfStudents++;
    } else if (models.batchModel.Students.length > 0) {
      console.log("second");
      students = models.batchModel.Students;
      students.push(key);
      models.batchModel.Students = students;
      models.batchModel.NoOfStudents++;
    }

    json.students = utils.mapDatabaseFields(models.studentModel);
    json.studentProfile = utils.mapDatabaseFields(models.studentProfileModel);
    json.batch = utils.mapDatabaseFields(models.batchModel);

    var studentRef = db.collection(this.collectionName).doc(key);
    batch.set(studentRef, json.students);

    var StudentsprofileRef = db.collection("studentsprofile").doc(key);
    batch.set(StudentsprofileRef, json.studentProfile);

    var BatchRef = db.collection("batches").doc(models.batchModel.Id);
    batch.update(BatchRef, json.batch);
    //console.log(batch);

    return new Promise(function(resolve, reject) {
      // Commit the batch
      batch
        .commit()
        .then(function() {
          response.isCommitted = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  async updateStudentToBatch(Id, models) {
    var response = { isCommitted: false, error: "" };
    // Get a new write batch
    var batch = db.batch();
    const key = Id;
    var students = [];
    var json = { students: null, studentProfile: null, batch: null };
    //console.log(key);

    json.students = utils.mapDatabaseFields(models.studentModel);
    json.studentProfile = utils.mapDatabaseFields(models.studentProfileModel);

    //console.log(models);
    var studentRef = db.collection(this.collectionName).doc(key);
    batch.set(studentRef, json.students);

    var StudentsprofileRef = db.collection("studentsprofile").doc(key);
    batch.set(StudentsprofileRef, json.studentProfile);

    //check if batch is changed
    var batchId = models.model.Batch;
    var changedBatchId = models.studentModel.Batch;
    console.log(batchId);
    console.log(changedBatchId);

    if (batchId != changedBatchId) {
      //batch is changed in the edit form so remove student from earlier batch and add to new batch

      //remove old batch info
      students = models.batchModel.Students;
      students = utils.removeArrayElement(students, Id);
      models.batchModel.Students = students;
      models.batchModel.NoOfStudents--;

      json.batch = utils.mapDatabaseFields(models.batchModel);

      var BatchRefOld = db.collection("batches").doc(batchId);
      batch.update(BatchRefOld, json.batch);

      //add new batch
      students = [];
      if (
        models.editedBatchModel.Students == undefined ||
        models.editedBatchModel.Students == "" ||
        models.editedBatchModel.Students == []
      ) {
        //first student for the batch
        students.push(key);
        models.editedBatchModel.Students = students;
        models.editedBatchModel.NoOfStudents++;
      } else if (models.editedBatchModel.Students.length > 0) {
        //second student
        students = models.editedBatchModel.Students;
        students.push(key);
        models.editedBatchModel.Students = students;
        models.editedBatchModel.NoOfStudents++;
      }

      json.batch = utils.mapDatabaseFields(models.editedBatchModel);

      var BatchRefNew = db.collection("batches").doc(changedBatchId);
      batch.update(BatchRefNew, json.batch);
    }

    //console.log(batch);

    return new Promise(function(resolve, reject) {
      // Commit the batch
      batch
        .commit()
        .then(function() {
          response.isCommitted = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  updateStudent(model) {
    //console.log(model)
    var json = utils.mapDatabaseFields(model);
    var collection = this.collectionName;
    var response = { isUpdated: false, error: "" };

    return new Promise(function(resolve, reject) {
      var docRef = db.collection(collection).doc(model.Id);
      docRef
        .update(json)
        .then(function() {
          response.isUpdated = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  async updateStudentsProperties(students, json) {
    var response = { isCommitted: false, error: "" };

    // Get a new write batch
    var batch = db.batch();

    students.forEach(element => {
      var docRef = db.collection(this.collectionName).doc(element);
      batch.update(docRef, json);
    });

    //console.log(batch);

    return new Promise(function(resolve, reject) {
      // Commit the batch
      batch
        .commit()
        .then(function() {
          response.isCommitted = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  async markAttendance(students, date) {
    var response = { isCommitted: false, error: "" };

    var batch = this.getAttendanceInfo(students, date);

    //console.log(batch);

    return new Promise(function(resolve, reject) {
      // Commit the batch
      batch
        .commit()
        .then(function() {
          response.isCommitted = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  getAttendanceInfo(payload, date) {
    var batch = db.batch();
    var studentsKeys = Object.keys(payload);
    studentsKeys.forEach(element => {
      var key = element;
      var value = payload[key].status;
      var attendancePercentAndDropoutJson = {};
      var docRef = db.collection(this.collectionName).doc(element);
      var docRefProgress = db.collection("studentprogress").doc(element);
      attendancePercentAndDropoutJson = this.getAttendanceAndDropoutInfo(
        value,
        payload[key].studentInfo,
        date
      );
      var json = { Attendance: {} };
      json.Attendance[date] = value;
      //console.log(attendancePercentAndDropoutJson);
      //console.log(json);
      batch.set(docRef, json, { merge: true });
      batch.update(docRef, attendancePercentAndDropoutJson.attendance_percent);
      batch.set(docRefProgress, attendancePercentAndDropoutJson.dropout, {
        merge: true
      });
    });

    return batch;
  }

  getAttendanceAndDropoutInfo(value, record, date) {
    var attendancePercentAndDropoutJson = {};
    if (value) {
      attendancePercentAndDropoutJson = this.setupAttendanceAndDropout(
        record,
        "present",
        date
      );
    } else {
      attendancePercentAndDropoutJson = this.setupAttendanceAndDropout(
        record,
        "absent",
        date
      );
    }
    //console.log(attendancePercentAndDropoutJson);

    return attendancePercentAndDropoutJson;
  }

  setupAttendanceAndDropout(record, status, date) {
    var attendance = {};
    var data = {};
    var dropout = {};
    var present = 0;
    var percent = 0;
    var dropoutThreshold = 2;
    var isDropout = false;

    Object.assign(attendance, record.Attendance);
    var attendanceKeys = Object.keys(attendance);
    var days = attendanceKeys.length;

    present = utils.getDaysPresent(days, attendanceKeys, attendance);

    isDropout = utils.getDropoutStatus(
      days,
      dropoutThreshold,
      attendanceKeys,
      attendance,
      status
    );

    percent = utils.getAttendancePercentage(present, days, status);

    if (isDropout) {
      dropout.dropped_out = isDropout;
      dropout.dropped_out_on = date;
    } else {
      dropout.dropped_out = isDropout;
    }

    data = {
      attendance_percent: { attendance_percent: percent },
      dropout: dropout
    };

    return data;
  }

  updateStudentProperty(Id, json) {
    //console.log(model)
    var collection = this.collectionName;
    var response = { isUpdated: false, error: "" };

    return new Promise(function(resolve, reject) {
      var docRef = db.collection(collection).doc(Id);
      docRef
        .update(json)
        .then(function() {
          response.isUpdated = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  deleteStudent(Id) {
    var collection = this.collectionName;
    var response = { isDeleted: false, error: "" };

    if (Id != null) {
      return new Promise(function(resolve, reject) {
        var docRef = db.collection(collection).doc(Id);
        docRef
          .delete()
          .then(function() {
            response.isDeleted = true;
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    } else {
      return new Promise(function(resolve, reject) {
        response.error = "Student with Id" + Id + " not found";
        reject(response);
      });
    }
  }

  getCollectionName() {
    console.log(this.collectionName);
  }
}

export default new StudentStore("students");
/*
// declare exports for our 'studentStore.js' module
module.exports = {
  deleteStudent: deleteStudent,
  addStudent: addStudent,
  updateStudent: updateStudent,
  printMessage : printMessage
};
*/
